"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
exports.isObject = isObject;
exports.mergeDeep = mergeDeep;

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _de = _interopRequireDefault(require("./de"));

var _en = _interopRequireDefault(require("./en"));

var _es = _interopRequireDefault(require("./es"));

var _fr = _interopRequireDefault(require("./fr"));

var _it = _interopRequireDefault(require("./it"));

var _ja = _interopRequireDefault(require("./ja"));

var _ko = _interopRequireDefault(require("./ko"));

var _pl = _interopRequireDefault(require("./pl"));

var _pt = _interopRequireDefault(require("./pt"));

var _ru = _interopRequireDefault(require("./ru"));

var _tr = _interopRequireDefault(require("./tr"));

var _zh = _interopRequireDefault(require("./zh"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty2(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty2(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function isObject(item) {
  return item && (0, _typeof2.default)(item) === "object" && !(0, _isArray.default)(item);
}

function mergeDeep(target, source) {
  var output = _objectSpread({}, target);

  if (isObject(target) && isObject(source)) {
    var _context;

    (0, _forEach.default)(_context = (0, _keys.default)(source)).call(_context, function (key) {
      if (isObject(source[key])) {
        if (!(key in target)) (0, _assign.default)(output, (0, _defineProperty2.default)({}, key, source[key]));else output[key] = mergeDeep(target[key], source[key]);
      } else {
        (0, _assign.default)(output, (0, _defineProperty2.default)({}, key, source[key]));
      }
    });
  }

  return output;
}

var templateStrings = {};
templateStrings.en = _en.default;
templateStrings.de = mergeDeep(_en.default, _de.default);
templateStrings.es = mergeDeep(_en.default, _es.default);
templateStrings.fr = mergeDeep(_en.default, _fr.default);
templateStrings.it = mergeDeep(_en.default, _it.default);
templateStrings.ja = mergeDeep(_en.default, _ja.default);
templateStrings.ko = mergeDeep(_en.default, _ko.default);
templateStrings.pl = mergeDeep(_en.default, _pl.default);
templateStrings.pt = mergeDeep(_en.default, _pt.default);
templateStrings.ru = mergeDeep(_en.default, _ru.default);
templateStrings.tr = mergeDeep(_en.default, _tr.default);
templateStrings.zh = mergeDeep(_en.default, _zh.default);
var _default = templateStrings;
exports.default = _default;